import { form } from '../formState'

import { useTexts } from '../../hooks/useTexts'
import { createValidateCompanySlogan } from '../hooks/useFormValidation'

export function CompanySlogan() {
  const texts = useTexts()

  form.useAddFieldValidation<'companySlogan'>('companySlogan', async (field, _formApi) => {
    const companySloganValidation = await createValidateCompanySlogan(texts, field.value)
    return companySloganValidation.companySloganMaxLengthError?.message
  })

  return (
    <form.TextField
      name="companySlogan"
      label={texts.companySlogan}
      testId="companySlogan"
      validateOn="focus blur change"
    />
  )
}
